import React from "react";
import ReactDOM from "react-dom";
import "./styles/index.css";
import Routes from "./Routes";
import { create } from "jss";
import rtl from "jss-rtl";
import { createTheme } from "@mui/material/styles";
import { TextField } from "@mui/material";
import { StylesProvider, ThemeProvider, jssPreset } from "@mui/styles";
import { StyledEngineProvider } from "@mui/material/styles";
import { heIL } from "@mui/material/locale";
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';

// Configure JSS
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const theme = createTheme(
  {
    direction: "rtl",
  },
  heIL
);


// Create RTL cache
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

ReactDOM.render(
  <CacheProvider value={cacheRtl}>

  <StylesProvider jss={jss}>
    <ThemeProvider theme={theme}>
      <Routes />
    </ThemeProvider>
  </StylesProvider>
  </CacheProvider>,


  document.querySelector("#root")
);
